const API_BASE_URL = 'https://vippshurtigcheckout.vercel.app';

export async function fetchOrderDetails() {
    try {
        console.log('[DEBUG] Starting fetchOrderDetails');
        console.log('[DEBUG] Current URL:', window.location.href);
        
        const pathParts = window.location.pathname.split('/').filter(Boolean);
        console.log('[DEBUG] Path parts:', pathParts);
        
        const id = pathParts[0];
        const token = pathParts[1];

        console.log('[DEBUG] Extracted values:', { id, token });

        // Test order ID condition
        if (id === '5677153255477') {
            console.log('[DEBUG] Using test order mock data');
            const mockData = {
                orderNumber: "1224",
                createdAt: new Date().toISOString(),
                customer: {
                    email: "test@example.com",
                    shippingAddress: {
                        name: "Test User",
                        address1: "Test Street 123",
                        city: "Oslo",
                        zip: "0150",
                        country: "Norway"
                    }
                },
                items: [{
                    title: "Test Product",
                    quantity: 1,
                    price: 179.00
                }],
                totalPrice: 258.00,
                shippingPrice: 79.00
            };
            console.log('[DEBUG] Mock data:', mockData);
            return mockData;
        }

        if (!id || !token) {
            console.error('[ERROR] Missing id or token');
            throw new Error('Manglende ordre-ID eller token');
        }

        const apiUrl = `${API_BASE_URL}/api/order/${id}/${token}`;
        console.log('[DEBUG] Fetching from API:', apiUrl);

        const response = await fetch(apiUrl);
        console.log('[DEBUG] API response status:', response.status);
        
        const data = await response.json();
        console.log('[DEBUG] API response data:', data);
        
        if (!response.ok) {
            throw new Error(data.error || 'Ukjent feil');
        }
        
        return data;
    } catch (error) {
        console.error('[ERROR] API error:', error);
        throw error;
    }
}